import { getAnnouncementsByDisplayType } from '../config/announcements';
import { AnnouncementBanner } from './AnnouncementBanner';

/**
 * Centrally manages multiple persistent announcement banners.
 * Automatically renders all announcements configured with showBanner: true.
 * Each banner handles its own feature flag and dismissal state.
 */
export function AnnouncementBannerCenter() {
  const announcements = getAnnouncementsByDisplayType('banner');

  if (announcements.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col">
      {announcements.map((announcement) => (
        <AnnouncementBanner key={announcement.id} announcement={announcement} />
      ))}
    </div>
  );
}
